import { FC } from "react";

import { Stack, Grid } from "capitalrx-components-2.0/lib/layout";
import { Semibold } from "capitalrx-components-2.0/lib/typography";
import { useResponsive } from "capitalrx-components-2.0/lib/layout";

import styles from "./DetailsList.module.scss";


export type DetailsListProps = {
  data: Record<string, string>;
  testId?: string;
};


export const DetailsList: FC<DetailsListProps> = ({ data, testId }) => {

  const { six_twelve_columns } = useResponsive({
    six_twelve_columns: {
      desktop: 6,
      tablet: 6,
      mobile: 12,
    },
  });

  return (
    <Stack className={styles.DetailsList} testId={testId}>
      {
        Object.keys(data).map((key) => {
          return (
            <Grid key={key} className={styles.Detail} spacing="mini">
              <Grid.Span columns={six_twelve_columns}><Semibold>{key}</Semibold></Grid.Span>
              <Grid.Span columns={six_twelve_columns}>{data[key]}</Grid.Span>
            </Grid>
          );
        })
      }
    </Stack>
  );
};
